import { createSelector } from '@reduxjs/toolkit';
import { selectApp } from './selectApp';

/** Select flag that indicates that template was changed */
export const selectIsTemplateChanged = createSelector(
  [selectApp],
  (state) => state.isTemplateChanged
);
